module.exports = __webpack_public_path__ + "img/valance-whale.bc140911.svg";